import React, { useState } from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";

const cards: Card[] = [
  // 500-800 sqft
  {
    img: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Farchitecture%2Flayout%2F500-800%2F1.jpeg?alt=media&token=6afd3129-c767-45c3-b9c9-5834b905a6c2",
    projectType: "residential",
    location: "Jaipur",
    length: 15,
    width: 35,
    floors: 1,
    direction: "North-West",
  },
  {
    img: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Farchitecture%2Flayout%2F500-800%2F2.jpeg?alt=media&token=60011caa-c1d5-4e63-b4c8-1351b2038d80",
    projectType: "residential",
    location: "Kolkata",
    length: 20,
    width: 25,
    floors: 1,
    direction: "South",
  },
  {
    img: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Farchitecture%2Flayout%2F500-800%2F3.jpeg?alt=media&token=e0c2ed7e-cca0-4c88-a8ee-45688a2d320c",
    projectType: "residential",
    location: "Delhi",
    length: 20,
    width: 25,
    floors: 2,
    direction: "North",
  },
  {
    img: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Farchitecture%2Flayout%2F500-800%2F4.jpeg?alt=media&token=0cb89ef9-7544-4500-b2ea-538b8a1d2654",
    projectType: "residential",
    location: "Bangalore",
    length: 25,
    width: 20,
    floors: 2,
    direction: "North",
  },
  {
    img: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Farchitecture%2Flayout%2F500-800%2F5.jpeg?alt=media&token=5399eb76-a01d-45a3-ac40-06de88968db9",
    projectType: "commercial",
    location: "Ranchi",
    length: 25,
    width: 20,
    floors: 2,
    direction: "South-East",
  },
  {
    img: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Farchitecture%2Flayout%2F500-800%2F6.jpeg?alt=media&token=33dadaeb-00e8-4167-b853-ebfd88d4fc25",
    projectType: "residential",
    location: "Ranchi",
    length: 25,
    width: 22,
    floors: 1,
    direction: "East",
  },
  // 800-1200 sqft
  {
    img: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Farchitecture%2Flayout%2F800-1200%2F1.jpeg?alt=media&token=cd4f6164-b9cf-40f0-a17c-0e188b31784f",
    projectType: "residential",
    location: "Coimbatore",
    length: 32,
    width: 32,
    floors: 1,
    direction: "North-East",
  },
  {
    img: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Farchitecture%2Flayout%2F800-1200%2F2.jpeg?alt=media&token=68afa9ae-a6a8-4fb0-8be9-12b0403103ac",
    projectType: "commercial",
    location: "Pune",
    length: 32,
    width: 28,
    floors: 2,
    direction: "South-West",
  },
  {
    img: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Farchitecture%2Flayout%2F800-1200%2F3.jpeg?alt=media&token=18dd0e3a-5d34-4238-a77b-17c0c87ebaae",
    projectType: "commercial",
    location: "Delhi",
    length: 30,
    width: 28,
    floors: 3,
    direction: "East",
  },
  {
    img: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Farchitecture%2Flayout%2F800-1200%2F4.jpeg?alt=media&token=248cb370-521a-4c44-81e7-5b3203dde6dc",
    projectType: "residential",
    location: "Dehradhun",
    length: 30,
    width: 30,
    floors: 2,
    direction: "North-East",
  },
  {
    img: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Farchitecture%2Flayout%2F800-1200%2F5.jpeg?alt=media&token=5a1e2274-57a6-452a-9cca-1ed819a801ee",
    projectType: "residential",
    location: "Kolkata",
    length: 30,
    width: 30,
    floors: 3,
    direction: "East",
  },
  {
    img: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Farchitecture%2Flayout%2F800-1200%2F5.jpeg?alt=media&token=5a1e2274-57a6-452a-9cca-1ed819a801ee",
    projectType: "residential",
    location: "Siliguri",
    length: 30,
    width: 30,
    floors: 3,
    direction: "East",
  },

  {
    img: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Farchitecture%2Flayout%2F1200-1600%2F1.jpeg?alt=media&token=6a3fe3f8-99cb-4520-8639-e3eddc423863",
    projectType: "commercial",
    location: "Siliguri",
    length: 32,
    width: 38,
    floors: 2,
    direction: "West",
  },
  {
    img: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Farchitecture%2Flayout%2F1200-1600%2F2.jpeg?alt=media&token=df4012e3-98e3-4346-abc0-282dc8155c03",
    projectType: "commercial",
    location: "Hyderabad",
    length: 25,
    width: 50,
    floors: 3,
    direction: "West",
  },
  {
    img: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Farchitecture%2Flayout%2F1200-1600%2F3.jpeg?alt=media&token=5ef867f4-c667-4ebc-ade3-8364c524f969",
    projectType: "commercial",
    location: "Ahmedabad",
    length: 40,
    width: 40,
    floors: 3,
    direction: "West",
  },
  {
    img: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Farchitecture%2Flayout%2F1200-1600%2F4.jpeg?alt=media&token=39683afd-44e9-4542-9ee3-c6eb5295a0c3",
    projectType: "commercial",
    location: "Siliguri",
    length: 35,
    width: 45,
    floors: 2,
    direction: "West",
  },
  {
    img: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Farchitecture%2Flayout%2F1200-1600%2F5.jpeg?alt=media&token=75b8ce23-44bf-454c-931b-82c044e29684",
    projectType: "commercial",
    location: "Hyderabad",
    length: 35,
    width: 40,
    floors: 3,
    direction: "West",
  },
  {
    img: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Farchitecture%2Flayout%2F1200-1600%2F5.jpeg?alt=media&token=75b8ce23-44bf-454c-931b-82c044e29684",
    projectType: "commercial",
    location: "Ahmedabad",
    length: 40,
    width: 50,
    floors: 3,
    direction: "West",
  },
  {
    img: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Farchitecture%2Flayout%2F1200-1600%2F6.jpeg?alt=media&token=470b8cd8-77ab-4f8b-904d-b28b9bf7b73e",
    projectType: "residential",
    location: "Coimbatore",
    length: 40,
    width: 42,
    floors: 1,
    direction: "North-East",
  },
  // 1600-2000 sqft
  {
    img: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Farchitecture%2Flayout%2F1600-2000%2F1.jpeg?alt=media&token=bde1c3e3-30f8-4f49-9576-05015524140a",
    projectType: "commercial",
    location: "Pune",
    length: 32,
    width: 50,
    floors: 2,
    direction: "South-West",
  },
  {
    img: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Farchitecture%2Flayout%2F1600-2000%2F1.jpeg?alt=media&token=bde1c3e3-30f8-4f49-9576-05015524140a",
    projectType: "commercial",
    location: "Delhi",
    length: 45,
    width: 40,
    floors: 3,
    direction: "East",
  },
  {
    img:"https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Farchitecture%2Flayout%2F1600-2000%2F3.jpeg?alt=media&token=4681594a-53e4-49c6-9fd5-59acfe9f4e3c",
    projectType: "residential",
    location: "Dehradhun",
    length: 35,
    width: 55,
    floors: 2,
    direction: "North-East",
  },
  {
    img: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Farchitecture%2Flayout%2F1600-2000%2F4.jpeg?alt=media&token=63c0232a-7244-4c91-bf19-3a6b3fd23255",
    projectType: "residential",
    location: "Kolkata",
    length: 48,
    width: 42,
    floors: 3,
    direction: "East",
  },
  {
    img: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Farchitecture%2Flayout%2F1600-2000%2F5.jpeg?alt=media&token=f5d3c1e8-86c4-4083-91fd-cccdebefe9c2",
    projectType: "residential",
    location: "Siliguri",
    length: 38,
    width: 50,
    floors: 3,
    direction: "East",
  },
  {
    img: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Farchitecture%2Flayout%2F1600-2000%2F6.jpeg?alt=media&token=bb2244c5-0714-47f7-a097-cbb7f1f07c72",
    projectType: "residential",
    location: "Coimbatore",
    length: 38,
    width: 50,
    floors: 3,
    direction: "East",
  },
  {
    img: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Farchitecture%2Flayout%2F2000%2B%2F1.jpeg?alt=media&token=2346d3ca-8d81-4e43-afd7-1eef9b1974fd",
    projectType: "residential",
    location: "Coimbatore",
    length: 45,
    width: 50,
    floors: 1,
    direction: "North-East",
  },
  {
    img: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Farchitecture%2Flayout%2F2000%2B%2F2.jpeg?alt=media&token=84c9a4af-2da9-4583-87ff-4d0e701c19fc",
    projectType: "commercial",
    location: "Pune",
    length: 40,
    width: 55,
    floors: 2,
    direction: "South-West",
  },
  {
    img:"https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Farchitecture%2Flayout%2F2000%2B%2F3.jpeg?alt=media&token=7a445cd8-a5a8-48b9-a8c9-4f29e4b70015",
    projectType: "commercial",
    location: "Delhi",
    length: 48,
    width: 50,
    floors: 3,
    direction: "East",
  },
  {
    img: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Farchitecture%2Flayout%2F2000%2B%2F4.jpeg?alt=media&token=80cff23f-1bb7-4c4f-a150-feddbfa8bbb8",
    projectType: "residential",
    location: "Dehradhun",
    length: 42,
    width: 52,
    floors: 2,
    direction: "North-East",
  },
  {
    img: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Farchitecture%2Flayout%2F2000%2B%2F5.jpeg?alt=media&token=4e0c12af-0e84-49e8-9c88-d82f31589995",
    projectType: "residential",
    location: "Kolkata",
    length: 35,
    width: 60,
    floors: 3,
    direction: "East",
  },
  {
    img: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Farchitecture%2Flayout%2F2000%2B%2F6.jpeg?alt=media&token=ec401ab8-0e29-4bb8-8e48-c64e24ff793a",
    projectType: "residential",
    location: "Siliguri",
    length: 50,
    width: 50,
    floors: 3,
    direction: "East",
  },
];

interface Card {
  img: any;
  projectType: "residential" | "commercial";
  location: string;
  length: number;
  width: number;
  floors: number;
  direction: string;
  image?: string;
}

const Floorplan = () => {
  const [filteredPlans, setFilteredPlans] = useState<Card[]>(cards);
  const [lengthFilter, setLengthFilter] = useState<number | string>("");
  const [widthFilter, setWidthFilter] = useState<number | string>("");
  const [areaFilter, setAreaFilter] = useState<number | string>("");
  const [floorsFilter, setFloorsFilter] = useState<number | string>("");
  const [directionFilter, setDirectionFilter] = useState<string>("");
  const [sidebarOpen, setSidebarOpen] = useState<boolean>(false);

  const handleFilter = () => {
    let filtered = cards;

    if (lengthFilter) {
      filtered = filtered.filter(
        (card) => card.length === Number(lengthFilter)
      );
    }

    if (widthFilter) {
      filtered = filtered.filter((card) => card.width === Number(widthFilter));
    }

    if (areaFilter) {
      filtered = filtered.filter(
        (card) => card.length * card.width === Number(areaFilter)
      );
    }

    if (floorsFilter) {
      filtered = filtered.filter(
        (card) => card.floors === Number(floorsFilter)
      );
    }

    if (directionFilter) {
      filtered = filtered.filter(
        (card) => card.direction.toLowerCase() === directionFilter.toLowerCase()
      );
    }

    setFilteredPlans(filtered);
  };

  return (
    <div className="flex flex-col min-h-screen bg-gray-100">
      <Header />

      <div className="flex-grow flex md:mt-32">
        {/* Sidebar Button */}
        <button
          onClick={() => setSidebarOpen(!sidebarOpen)}
          className="md:hidden absolute w-14 z-50 p-1.5 h-10 top-32 left-0 flex rounded-r-full bg-gray-800 text-white"
        >
          {sidebarOpen ? "Close" : "Open"}
        </button>

        {/* Sidebar */}
        <div
          className={`md:w-1/4 w-full p-4 bg-base-200 rounded ${
            sidebarOpen ? "block" : "hidden md:block"
          }`}
        >
          <h1 className="font-black text-[1rem] md:text-[2rem] my-3 font-[Italiana] text-center">
            Floorplan
          </h1>
          <ul className="menu bg-base-100 divide-y rounded-box shadow">
            <li
              className="py-2 text-center cursor-pointer hover:bg-gray-700 focus:text-gray-900 hover:text-white"
              onClick={() => setFilteredPlans(cards)}
            >
              All
            </li>
            <li
              className="py-2 text-center cursor-pointer hover:bg-gray-700 focus:text-gray-900 hover:text-white"
              onClick={() =>
                setFilteredPlans(
                  cards.filter(
                    (card) =>
                      card.length * card.width >= 500 &&
                      card.length * card.width <= 800
                  )
                )
              }
            >
              500 Sqft - 800 Sqft
            </li>
            <li
              className="py-2 text-center cursor-pointer hover:bg-gray-700 focus:text-gray-900 hover:text-white"
              onClick={() =>
                setFilteredPlans(
                  cards.filter(
                    (card) =>
                      card.length * card.width > 800 &&
                      card.length * card.width <= 1200
                  )
                )
              }
            >
              800 Sqft - 1200 Sqft
            </li>
            <li
              className="py-2 text-center cursor-pointer hover:bg-gray-700 focus:text-gray-900 hover:text-white"
              onClick={() =>
                setFilteredPlans(
                  cards.filter(
                    (card) =>
                      card.length * card.width > 1200 &&
                      card.length * card.width <= 1600
                  )
                )
              }
            >
              1200 Sqft - 1600 Sqft
            </li>
            <li
              className="py-2 text-center cursor-pointer hover:bg-gray-700 focus:text-gray-900 hover:text-white"
              onClick={() =>
                setFilteredPlans(
                  cards.filter(
                    (card) =>
                      card.length * card.width > 1600 &&
                      card.length * card.width <= 2000
                  )
                )
              }
            >
              1600 Sqft - 2000 Sqft
            </li>
            <li
              className="py-2 text-center cursor-pointer hover:bg-gray-700 focus:text-gray-900 hover:text-white"
              onClick={() =>
                setFilteredPlans(
                  cards.filter((card) => card.length * card.width > 2000)
                )
              }
            >
              2000 Sqft and More
            </li>
          </ul>

          <h1 className="font-black text-[1rem] md:text-[2rem] my-3 font-[Italiana] text-center">
            Filter
          </h1>

          <div className="menu bg-base-100 divide-y rounded-box p-4 shadow">
            <div className="flex mb-2">
              <input
                type="number"
                placeholder="Length"
                value={lengthFilter}
                onChange={(e) => setLengthFilter(e.target.value)}
                className="input input-bordered w-full mr-2"
              />
              <input
                type="number"
                placeholder="Width"
                value={widthFilter}
                onChange={(e) => setWidthFilter(e.target.value)}
                className="input input-bordered w-full"
              />
            </div>
            <input
              type="number"
              placeholder="Area"
              value={areaFilter}
              onChange={(e) => setAreaFilter(e.target.value)}
              className="input input-bordered w-full mb-2"
            />
            <input
              type="number"
              placeholder="Floors"
              value={floorsFilter}
              onChange={(e) => setFloorsFilter(e.target.value)}
              className="input input-bordered w-full mb-2"
            />
            <input
              type="text"
              placeholder="Direction"
              value={directionFilter}
              onChange={(e) => setDirectionFilter(e.target.value)}
              className="input input-bordered w-full mb-2"
            />
            <button
              onClick={handleFilter}
              className="btn text-slate-100 bg-slate-700 w-full"
            >
              Search
            </button>
          </div>
        </div>

        {/* Main Content */}
        <div className="flex-1 p-4 flex flex-wrap justify-center h-screen overflow-y-scroll scroll-hide bg-base-100">
          {filteredPlans.length > 0 ? (
            filteredPlans.map((plan, index) => (
              <div
                key={index}
                className="card max-h-[500px] w-80 flex-shrink bg-white hover:shadow-xl border  m-4"
              >
                <div className="card-body p-2">
                  {/* Image Placeholder */}
                  <div className="my-4 bg-gray-200 flex items-center justify-center">
                    <img
                      className="text-gray-400 h-38 object-cover"
                      src={plan.img}
                    />
                  </div>

                  {/* Plan Type and Location */}
                  <div className="flex justify-between bg-gray-800 text-white p-2 rounded">
                    <span className="text-sm">{plan.location}</span>
                    <span className="text-sm font-bold">
                      {plan.projectType.charAt(0).toUpperCase() +
                        plan.projectType.slice(1)}{" "}
                      Project
                    </span>
                  </div>

                  {/* Four Parameters */}
                  <div className="grid grid-cols-2 gap-2">
                    <div className="bg-gray-100 p-1 rounded text-center">
                      <p className="text-gray-600 text-sm">
                        {plan.length} ft X {plan.width} ft
                      </p>
                    </div>
                    <div className="bg-gray-100 p-1 rounded text-center">
                      <p className="text-gray-600 text-sm">
                        {plan.width * plan.length} sqft
                      </p>
                    </div>
                    <div className="bg-gray-100 p-1 rounded text-center">
                      <p className="text-gray-600 text-sm">
                        {plan.floors} Floor
                      </p>
                    </div>
                    <div className="bg-gray-100 p-1 rounded text-center">
                      <p className="text-gray-600 text-sm">{plan.direction} </p>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p className="text-center text-lg">No plans found</p>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Floorplan;
